export default __webpack_public_path__ + "static/media/Arch_AWS-Inspector.eca97a15.svg";